import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Icons } from '@agro-club/agroclub-shared'
import styled from 'styled-components'
import { AButton, ASearch } from 'views/components/Analytics'
import { Pagination } from 'views/components/Pagination/Pagination'
import { CarItem } from './CarItem'
import { TabContentHeader, TabHeaderRightBlock } from '../styled'
import { LineSeparator } from 'views/ui/Header/Header'
import { useCars } from '../useCars'
import { CarriersKRAddCarModal } from '../../CarriersKRAddCar/CarriersKRAddCarModal'

const ItemList = styled.div`
  margin-bottom: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

interface Props {
  data: ReturnType<typeof useCars>
  carrierId: string
}

export const Cars: FC<Props> = ({ data, carrierId }) => {
  const { t } = useTranslation('logisticsKR')
  const [isModalOpened, setIsModalOpened] = useState(false)

  return (
    <div style={{ maxWidth: '900px', overflow: 'auto', height: '100%' }}>
      <TabContentHeader>
        {/*placeholder for align */}
        {data.total < (data.listRequestParams.pageSize || 0) && <div></div>}
        <Pagination
          disableMargin
          setCurrPage={(page) => data.setListRequestParams((prev) => ({ ...prev, page }))}
          currPage={data.listRequestParams.page}
          pageSize={data.listRequestParams.pageSize}
          total={data.total}
        />
        <TabHeaderRightBlock>
          <div style={{ width: '362px' }}>
            <ASearch
              value={data.listRequestParams.filter.search}
              onChange={(search) =>
                data.setListRequestParams((prev) => ({ ...prev, page: 1, filter: { ...prev.filter, search } }))
              }
              placeholder={t('common:search')}
            />
          </div>
          <LineSeparator />
          <AButton id="addCar" color="approve" Icon={Icons.IconPlus} onClick={() => setIsModalOpened(true)} />
        </TabHeaderRightBlock>
      </TabContentHeader>
      <div>
        {!!data.data?.length && (
          <ItemList>
            {data.data.map((car) => (
              <CarItem key={car.id} car={car} refetch={data.refetch} />
            ))}
          </ItemList>
        )}
        {isModalOpened && (
          <CarriersKRAddCarModal
            carrierId={carrierId}
            onSuccess={data.refetch}
            onClose={() => setIsModalOpened(false)}
          />
        )}
      </div>
    </div>
  )
}
